
export default function FloatingWhatsApp() {
  const message = encodeURIComponent('Hola, necesito información sobre limpieza post incendio en Barcelona.');
  
  return (
    <>
      {/* Floating WhatsApp Button - Desktop & Mobile */}
      <a
        href={`https://wa.me/34690220944?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex fixed bottom-6 right-6 w-16 h-16 bg-[#25D366] rounded-full items-center justify-center shadow-lg hover:scale-110 transition-transform z-50 cursor-pointer group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-fill text-white text-3xl"></i>
        <span className="absolute right-20 bg-primary text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
          Escríbenos
        </span>
      </a>
    </>
  );
}